export const Constants = {
  title: 'Área de Acesso',
  emailPlaceholder: 'digite seu e-mail de acesso',
  passwordPlaceholder: 'digite sua senha',
  submit: 'ENTRAR',
  forgotPassword: 'esqueci minha senha',
  click: 'Clique aqui',
};
